var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 37.5C16.5388 37.5 13.1554 36.4737 10.2775 34.5507C7.39967 32.6278 5.15665 29.8947 3.83212 26.697C2.50758 23.4993 2.16102 19.9806 2.83627 16.5859C3.51151 13.1913 5.17822 10.0731 7.62564 7.62564C10.0731 5.17822 13.1913 3.51151 16.5859 2.83627C19.9806 2.16102 23.4993 2.50758 26.697 3.83212C29.8947 5.15665 32.6278 7.39967 34.5507 10.2775C36.4737 13.1554 37.5 16.5388 37.5 20C37.5 24.6413 35.6563 29.0925 32.3744 32.3744C29.0925 35.6563 24.6413 37.5 20 37.5ZM20 5.00001C17.0333 5.00001 14.1332 5.87974 11.6665 7.52796C9.19972 9.17618 7.27713 11.5189 6.14181 14.2598C5.0065 17.0006 4.70945 20.0166 5.28823 22.9264C5.86701 25.8361 7.29562 28.5088 9.39341 30.6066C11.4912 32.7044 14.1639 34.133 17.0737 34.7118C19.9834 35.2906 22.9994 34.9935 25.7403 33.8582C28.4812 32.7229 30.8238 30.8003 32.4721 28.3336C34.1203 25.8668 35 22.9667 35 20C35 16.0218 33.4197 12.2065 30.6066 9.39341C27.7936 6.58036 23.9783 5.00001 20 5.00001V5.00001Z",
    fill: "#C1272D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.33325C20.9205 8.33325 21.6667 9.07945 21.6667 9.99992L21.6667 21.6666C21.6667 22.5871 20.9205 23.3333 20 23.3333V23.3333C19.0796 23.3333 18.3334 22.5871 18.3334 21.6666L18.3334 9.99992C18.3334 9.07945 19.0796 8.33325 20 8.33325V8.33325Z",
    fill: "#C1272D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 26.6667C20.9205 26.6667 21.6667 27.4129 21.6667 28.3333V28.3333C21.6667 29.2538 20.9205 30 20 30V30C19.0796 30 18.3334 29.2538 18.3334 28.3333V28.3333C18.3334 27.4129 19.0796 26.6667 20 26.6667V26.6667Z",
    fill: "#C1272D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.f405785c97a6a39b4b025399bc57e90c.svg";
export { ForwardRef as ReactComponent };